
require("./application")
require("../stylesheets/dentist")